import type { ValueOf } from '#layers/base/public';

/** How a row of a relation list relates to what the server has: unchanged, or staged in this form. */
export const RelatedItemStates = {
	Default: 'default',
	Created: 'created',
	Connected: 'connected',
	Disconnected: 'disconnected',
	Updated: 'updated',
} as const;

export type RelatedItemState = ValueOf<typeof RelatedItemStates>;
